{
  "version": 1,
  "asset_id": "dc2ee6f2-49ca-44cd-a899-3e566b0777e0",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/dc2ee6f2-49ca-44cd-a899-3e566b0777e0/raindrop-heavy-rain.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/dc2ee6f2-49ca-44cd-a899-3e566b0777e0/raindrop-heavy-rain.mp4",
  "original_filename": "raindrop-heavy-rain.mp4",
  "size": 12719845,
  "content_type": "video/mp4",
  "created_at": "2026-08-15T17:14:16Z"
}
